import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=09b913c3&scoped=true&"
import script from "./Dialogs.vue?vue&type=script&lang=js&"
export * from "./Dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b913c3",
  null
  
)

export default component.exports